import serverCall from "../../serverCall";

const getAllGroup = () => {
  try {
    const response = serverCall.get(`/training-group/getAll`);
    return response;
  } catch (error) {
    throw error;
  }
};
const getAllSuggettions = () => {
  try {
    const response = serverCall.get(`/training-group/allSuggestion`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getGroupDetails = (groupId) => {
  try {
    const response = serverCall.get(
      `/training-group/groupDetails?groupId=${groupId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createTrainingGroup = (body) => {
  try {
    const response = serverCall.post(`/training-group/create`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateGroup = (groupId, body) => {
  try {
    const response = serverCall.patch(`/training-group/updateDetails?groupId=${groupId}`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteUser = (userId) => {
  try {
    const response = serverCall.delete(`/admin/user/delete/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

/* const updateAdminProfile = (body, userId) => {
  try {
    const response = serverCall.patch(`/admin/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const adminFileUpload = (body) => {
  try {
    const response = serverCall.post(`/company/update-company`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const getCompany = () => {
  try {
    const response = serverCall.get(`/company/get-companies`);
    return response;
  } catch (error) {
    throw error;
  }
}; */

const TrainingService = {
  getAllGroup,
  getAllSuggettions,
  getGroupDetails,
  createTrainingGroup,
  updateGroup,
  deleteUser,
  //   updateAdminProfile,
  //   adminFileUpload,
  //   getCompany,
};

export default TrainingService;
